import React from 'react';

const Error = ({ error }) => {
  return <p className="error">{error}</p>;
};

export default Error;
